var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1599_2864204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 24.334C19.4399 24.334 24.8125 18.9614 24.8125 12.334C24.8125 5.70657 19.4399 0.333984 12.8125 0.333984C6.18508 0.333984 0.8125 5.70657 0.8125 12.334C0.8125 18.9614 6.18508 24.334 12.8125 24.334Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8134 5.0293L22.7265 12.3336L12.8134 19.638L2.90039 12.3336L12.8134 5.0293Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8126 16.5079C15.1177 16.5079 16.9865 14.6392 16.9865 12.334C16.9865 10.0289 15.1177 8.16016 12.8126 8.16016C10.5074 8.16016 8.63867 10.0289 8.63867 12.334C8.63867 14.6392 10.5074 16.5079 12.8126 16.5079Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7262 12.0742C10.0004 12.0742 9.29997 12.1846 8.64062 12.3895C8.66983 14.6694 10.5263 16.509 12.8132 16.509C14.2273 16.509 15.4763 15.8051 16.2313 14.7293C14.9395 13.1122 12.952 12.0742 10.7262 12.0742Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9106 13.1337C16.9609 12.8748 16.988 12.6077 16.988 12.3341C16.988 10.0288 15.1193 8.16016 12.8141 8.16016C11.0941 8.16016 9.61752 9.20083 8.97852 10.6867C9.54336 10.5696 10.1282 10.508 10.7272 10.508C13.1514 10.5079 15.3445 11.5157 16.9106 13.1337Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1599_2864204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.8125 0.333984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.503c05c49651875f909a2801e773a7c0.svg";
export { ForwardRef as ReactComponent };